export default __webpack_public_path__ + "static/media/pumaypay_connect.055d2e9c.png";